module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp2_8011.8f2fe239.png";